import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Tabs from "./Tabs";
import LaunchScreen from "../../screens/LaunchScreen";
import MessageScreen from "../../screens/MessageScreen";
import WorkplaceScreen from "../../screens/WorkplaceScreen";
import TreeDetailScreen from "../../screens/TreeDetailScreen";
import TreeCreateScreen from "../../screens/TreeCreateScreen";
import TreeListScreen from "../../screens/TreeListScreen";
import LoginScreen from "../../screens/LoginScreen";
import InspectCreateScreen from "../../screens/InspectCreacteScreen";
import TestScreen from "../../screens/TestScreen";
import InspectListScreen from "../../screens/InspectListScreen";

const AppNavigation: React.FC = React.memo((props) => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<LaunchScreen />}></Route>
          {/* 这个是临时页面，备案成功后需要删除掉的 TODO */}
          <Route path="/index" element={<TestScreen />}></Route>
          <Route path="/tabs" element={<Tabs />}></Route>
          <Route path="/login" element={<LoginScreen />}></Route>
          <Route path="/message" element={<MessageScreen />}></Route>
          {/* 工作区 */}
          <Route path="/workspace" element={<WorkplaceScreen />}></Route>
          {/* 树木详情（公众扫码后展示） */}
          <Route path="/tree/:id" element={<TreeDetailScreen />}></Route>
          {/* 一树一档列表 */}
          <Route path="/tree/list" element={<TreeListScreen />}></Route>
          {/* 树木建档 */}
          <Route path="/tree/create" element={<TreeCreateScreen />}></Route>
          {/* 巡查列表 */}
          <Route path="/inspect/list" element={<InspectListScreen />}></Route>
          <Route
            path="/inspect/create/:id"
            element={<InspectCreateScreen />}
          ></Route>
        </Routes>
      </Router>
    </div>
  );
});

export default AppNavigation;
